import * as fromAuthUsersExternal from './external/users-external.reducer';
import * as fromAuthUsersInternal from './internal/users-internal.reducer';
import * as fromAuthUsersGlobal from './global/users-global.reducer';

export const BackAuthUsersFeatureKey = 'users';

export interface IBackAuthUsersState
{
    [fromAuthUsersExternal.BackAuthUsersExternalFeatureKey]: fromAuthUsersExternal.IBackAuthUsersExternalState;
    [fromAuthUsersInternal.BackAuthUsersInternalFeatureKey]: fromAuthUsersInternal.IBackAuthUsersInternalState;
    [fromAuthUsersGlobal.BackAuthUsersGlobalFeatureKey]: fromAuthUsersGlobal.IBackUsersGlobalState;
}
export const BackAuthUsersInitialState: IBackAuthUsersState =
{
    [fromAuthUsersExternal.BackAuthUsersExternalFeatureKey]: fromAuthUsersExternal.BackAuthUsersExternalInitialState,
    [fromAuthUsersInternal.BackAuthUsersInternalFeatureKey]: fromAuthUsersInternal.BackAuthUsersInternalInitialState,
    [fromAuthUsersGlobal.BackAuthUsersGlobalFeatureKey]: fromAuthUsersGlobal.BackUsersGlobalInitialState
};
